import type { MiddlewareAPI } from 'redux';
import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { defaultTimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/constants.tsx';
import type { TimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';
import fetch from '../../rest/time-tracking-options';
import type { ResponseGQL } from '../../rest/time-tracking-options/types';
import { getBaseUrl } from '../../state/selectors/base';
import type { State } from '../../state/types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (store: MiddlewareAPI<State>): ObservableType<TimeTrackingOptions> => {
	const state = store.getState();
	const baseUrl = getBaseUrl(state);

	return fetch(baseUrl).map((result: ResponseGQL) => {
		if (result.errors || !result.data || !result.data.jira) {
			return defaultTimeTrackingOptions;
		}
		return result.data.jira.timeTrackingOptions;
	});
};
